// π ----
// :: MODULES BOOTSTRAP ---------------------------::
// ____

/* :: Imports
---------------------------------- */
import Vue from 'vue';

import animation from './partials/components/animate.vue';

import header from './partials/modules/header.vue';
import navigator from './partials/modules/navigator.vue';

import home from './templates/home.vue';
import about from './templates/about.vue';
import portfolio from './templates/portfolio.vue';
import project from './templates/project.vue';
import defaultPage from './templates/default.vue';

export default {
    init() {
        new Vue({
            el: '#thoconnor-root',

            components: {
                animation,
                'main-header': header,
                navigator,
                home,
                about,
                portfolio,
                project,
                defaultPage
            },

            data: {
                openNav: false,
                headerHeight: 0
            }
        });
    },
    finalize() {}
};
